import { Button } from "../../../../components/ui/Button";
import localization from "../../../../config/localization";
import { VerificationType } from "../../../../models/constants/verificationType";

export function VerificationMethood({ handleVerificationMethodChange }: { handleVerificationMethodChange: (method: string) => void }) {
    return (
        <div className="grid grid-cols-2 gap-4 w-full">
            <Button className="w-full bg-black border-[1.5px] border-[#242426] rounded-lg shadow flex flex-col items-center justify-center py-8 hover:bg-gray-900 transition"
                onClick={() => handleVerificationMethodChange(VerificationType.Email)}>
                <img src="/icons/ic-email.svg" alt="Email Icon" />
                <span className="text-white mt-2 font-bold">{localization.email}</span>
            </Button>

            <Button className="w-full bg-black border-[1.5px] border-[#242426] rounded-lg shadow flex flex-col items-center justify-center py-8 hover:bg-gray-900 transition"
                onClick={() => handleVerificationMethodChange(VerificationType.Mobile)}>
                <img src="/icons/ic-mobile.svg" alt="Phone Icon" />
                <span className="text-white mt-2 font-bold">{localization.mobile}</span>
            </Button>

            <div className="col-span-2 flex justify-center">
                <Button className="w-1/2 bg-black border-[1.5px] border-[#242426] rounded-lg shadow flex flex-col items-center justify-center py-8 hover:bg-gray-900 transition"
                    onClick={() => handleVerificationMethodChange(VerificationType.Both)}>
                    <div className="flex gap-2">
                        <img src="/icons/ic-email.svg" alt="" />
                        <img src="/icons/ic-mobile.svg" alt="" />
                    </div>
                    <span className="text-white mt-2 font-bold">{localization.both}</span>
                </Button>
            </div>
        </div>
    );
}
